import React, { useEffect, useState } from 'react';

import { Box, Text } from '@betterment/samba-react';

import disclosureInitializer from './disclosureInitializer';

import { FooterText } from '../Shared/components/Footer';

const FooterDisclosure: React.FC = () => {
  const [disclosures, setDisclosures] = useState<string[]>([]);

  useEffect(() => {
    disclosureInitializer.subscribe(value => {
      setDisclosures(Object.values(value).filter(Boolean));
    });

    return () => disclosureInitializer.unsubscribe();
  }, []);

  if (disclosures.length < 1) return null;

  return (
    <Box css={{ mb: 'space.300' }}>
      {disclosures.map(value => (
        <Text as="p" key={value} className={FooterText} dangerouslySetInnerHTML={{ __html: value }} />
      ))}
    </Box>
  );
};

export default FooterDisclosure;
